import DeleteCategoryConfirmPopup from "./DeleteCategoryConfirmPopup";

export default DeleteCategoryConfirmPopup;